import { motion } from 'framer-motion';
import { fadeSlideVariants, staggerListVariants } from '../ui/Motion.js';
import { BarChart2, Flame, Zap } from 'lucide-react';
import { StatCard } from '../ui/StatCard.js';
import { XPGauge } from '../ui/XPGauge.js';
const staggerContainer = staggerListVariants;

const staggerItem = fadeSlideVariants;

interface StatsSectionProps {
  streak: { currentStreak: number; longestStreak: number } | undefined;
  xp: number;
  level: number;
  levelTitle: string;
  xpProgress: number;
  xpForNext: number | null;
}

export function StatsSection({
  streak,
  xp,
  level,
  levelTitle,
  xpProgress,
  xpForNext,
}: StatsSectionProps) {
  return (
    <>
      <motion.div
        className="grid grid-cols-1 gap-4 sm:grid-cols-3"
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={staggerItem}>
          <StatCard
            icon={<BarChart2 className="h-5 w-5" />}
            label="Nivel"
            value={`${level} · ${levelTitle}`}
            color="accent"
            sub={xpForNext ? `${xpProgress}% → Nivel ${level + 1}` : 'Nivel máximo'}
          />
        </motion.div>
        <motion.div variants={staggerItem}>
          <StatCard
            icon={<Flame className="h-5 w-5" />}
            label="Racha actual"
            value={`${streak?.currentStreak ?? 0} días`}
            color="orange"
            sub={`Récord: ${streak?.longestStreak ?? 0} días`}
          />
        </motion.div>
        <motion.div variants={staggerItem}>
          <StatCard
            icon={<Zap className="h-5 w-5" />}
            label="XP Total"
            value={`${xp.toLocaleString()} XP`}
            color="xp"
            sub={
              xpForNext ? `${(xpForNext - xp).toLocaleString()} para nivel ${level + 1}` : undefined
            }
          />
        </motion.div>
      </motion.div>

      <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-5">
        <XPGauge
          xp={xp}
          xpForNext={xpForNext}
          level={level}
          levelTitle={levelTitle}
          progress={xpProgress}
        />
      </div>
    </>
  );
}
